import {
  Outlet,
  createRootRoute,
  createRoute,
  createRouter,
  redirect,
} from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const LoginPage = lazy(() =>
  import("../../features/auth/routes/LoginPage").then((module) => ({
    default: module.LoginPage,
  })),
);
const OrdersPage = lazy(() =>
  import("../../features/orders/routes/OrdersPage").then((module) => ({
    default: module.OrdersPage,
  })),
);
const BackupsPage = lazy(() =>
  import("../../features/backups/routes/BackupsPage").then((module) => ({
    default: module.BackupsPage,
  })),
);

function RouteFallback() {
  return (
    <div className="boot-screen">
      <div className="brand__mark" />
      <strong>Eurocut ERP</strong>
      <span>Munkaterület betöltése…</span>
    </div>
  );
}

const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/orders" });
  },
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: () => (
    <Suspense fallback={<RouteFallback />}>
      <LoginPage />
    </Suspense>
  ),
});

const ordersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/orders",
  component: () => (
    <Suspense fallback={<RouteFallback />}>
      <OrdersPage />
    </Suspense>
  ),
});

const backupsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/backups",
  component: () => (
    <Suspense fallback={<RouteFallback />}>
      <BackupsPage />
    </Suspense>
  ),
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  ordersRoute,
  backupsRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 10_000,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
